import ContentLoader from "@rio-cloud/rio-uikit/ContentLoader";

interface TransactionSummarySkeletonProps {
  columns?: number[];
}

const ENTITY_LABEL_HEIGHT = 14;
const ENTITY_LABEL_WIDTH = 80;
const LINE_HEIGHT = 20;
const ICON_SIZE = 18;

const LABEL_WIDTHS = [70, 105, 60, 130, 55, 90, 75, 110, 65, 95, 80, 120];
const VALUE_WIDTHS = [85, 70, 110, 60, 95, 75, 130, 65, 100, 80, 115, 70];

const LOADER_CLASS = "display-block skeleton-on-light-bg";

const DIVIDER_STYLE = { width: 1, flex: "0 0 auto" } as const;

export default function TransactionSummarySkeleton({
  columns = [2, 2, 2, 2],
}: Readonly<TransactionSummarySkeletonProps>) {
  let fieldIndex = 0;

  const columnsWithKey = columns.map((rows, columnIndex) => ({
    key: `transaction-summary-skeleton-column-${columnIndex}`,
    rows,
    hasDivider: columnIndex > 0,
  }));

  return (
    <div className="bg-lighter rounded-small padding-15">
      <span className="text-bold">
        <ContentLoader className="skeleton-on-light-bg" height={ENTITY_LABEL_HEIGHT} width={ENTITY_LABEL_WIDTH} />
      </span>

      <div className="display-flex flex-wrap gap-15 margin-top-10">
        {columnsWithKey.map((column) => (
          <div key={column.key} className="display-flex align-items-center gap-15">
            {column.hasDivider && <div className="bg-light hidden-xs align-self-stretch" style={DIVIDER_STYLE} />}
            <div className="display-flex flex-column gap-5 min-width-0">
              {Array.from({ length: column.rows }, () => {
                const index = fieldIndex++;

                return (
                  <div key={index} className="display-flex align-items-center gap-5 text-size-14">
                    <ContentLoader className={LOADER_CLASS} height={ICON_SIZE} width={ICON_SIZE} />
                    <ContentLoader
                      className={LOADER_CLASS}
                      height={LINE_HEIGHT}
                      width={LABEL_WIDTHS[index % LABEL_WIDTHS.length]}
                    />
                    <ContentLoader
                      className={LOADER_CLASS}
                      height={LINE_HEIGHT}
                      width={VALUE_WIDTHS[index % VALUE_WIDTHS.length]}
                    />
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
